export default "__VITE_ASSET__DtYuqqDY__"